import(/* webpackMode: "eager" */ "/app/apps/topshop/components/recommendations/recommendations.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/topshop/views/productDisplayView/segments/gallery-pane/gallery-pane.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/topshop/views/productDisplayView/segments/overview/overview.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/atoms/container/container.module.css");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/atoms/dynamic-height/dynamic-height.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/atoms/flex/flex.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/topshop/views/productDisplayView/segments/lower/lower.module.css");
